import appBustypes from "../../views/appSettings/bustypes.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "bustypes";
  const params = ["page", "limit", "sort"];

  $stateProvider.state("bustypes", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appBustypes,
      },
    },
    reloadOnSearch: false,
    data: { title: "Bustypes" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/bustypes/bustypes.urls.js